import type { MeteringStateToTitleMap } from "app/components/metering/types";
import { EMeteringCountRatio } from "app/components/metering/types";
import { getBannerTitleHOF } from "app/components/metering/utils";

import { getMeteringData } from "./IndustryAnalysisMetering";

const {
    ADMIN_BELOW_80,
    ADMIN_BELOW_100,
    ADMIN_EQUAL_100,
    ADMIN_ABOVE_100,
    BELOW_80,
    BELOW_100,
    EQUAL_100,
    ABOVE_100,
    CUSTOM_15_000,
    HARD_ADMIN_BELOW_80,
    HARD_ADMIN_BELOW_100,
    HARD_ADMIN_EQUAL_100,
    HARD_ADMIN_EQUAL_100_PLUS_1,
    HARD_ADMIN_ABOVE_100_PLUS_2,
    HARD_BELOW_80,
    HARD_BELOW_100,
    HARD_EQUAL_100,
    HARD_EQUAL_100_PLUS_1,
    HARD_ABOVE_100_PLUS_2,
} = EMeteringCountRatio;
const meteringStateToTitle: MeteringStateToTitleMap = {
    // soft
    [ADMIN_BELOW_80]: "industry.analysis.metering.limitation.disclaimer.count.only.admin",
    [ADMIN_BELOW_100]: "industry.analysis.metering.limitation.disclaimer.limit.approaching.admin",
    [ADMIN_EQUAL_100]: "industry.analysis.metering.limitation.disclaimer.limit.reached.admin",
    [ADMIN_ABOVE_100]: "industry.analysis.metering.limitation.disclaimer.limit.exceeded.admin",
    [BELOW_80]: "industry.analysis.metering.limitation.disclaimer.count.only",
    [BELOW_100]: "industry.analysis.metering.limitation.disclaimer.limit.approaching",
    [EQUAL_100]: "industry.analysis.metering.limitation.disclaimer.limit.reached",
    [ABOVE_100]: "industry.analysis.metering.limitation.disclaimer.limit.exceeded",
    [CUSTOM_15_000]: "industry.analysis.metering.limitation.disclaimer.count.only",
    // hard
    [HARD_ADMIN_BELOW_80]: "industry.analysis.metering.limitation.disclaimer.count.only.hard.admin",
    [HARD_ADMIN_BELOW_100]: "industry.analysis.metering.limitation.disclaimer.limit.approaching.hard.admin",
    [HARD_ADMIN_EQUAL_100]: "industry.analysis.metering.limitation.disclaimer.limit.reached.hard.admin",
    [HARD_ADMIN_EQUAL_100_PLUS_1]: "industry.analysis.metering.limitation.disclaimer.limit.grace.hard.admin",
    [HARD_ADMIN_ABOVE_100_PLUS_2]: "industry.analysis.metering.limitation.disclaimer.limit.exceeded.hard.admin",
    [HARD_BELOW_80]: "industry.analysis.metering.limitation.disclaimer.count.only.hard",
    [HARD_BELOW_100]: "industry.analysis.metering.limitation.disclaimer.limit.approaching.hard",
    [HARD_EQUAL_100]: "industry.analysis.metering.limitation.disclaimer.limit.reached.hard",
    [HARD_EQUAL_100_PLUS_1]: "industry.analysis.metering.limitation.disclaimer.limit.grace.hard",
    [HARD_ABOVE_100_PLUS_2]: "industry.analysis.metering.limitation.disclaimer.limit.exceeded.hard",
};

export const getBannerTitle = getBannerTitleHOF(getMeteringData, meteringStateToTitle);
